import React from "react";

import SummaryExport from "../components/SummaryExport.jsx";
import { EXTRA_FIELD_LABELS } from "../characterCreatorUtils.js";

export default function SummaryStep({
  summaryRows,
  extraFields,
  exportType,
  exportSnapshot,
  onExportTypeChange,
  onExtraFieldChange,
}) {
  return (
    <>
      <div className="summary-grid" id="summaryGrid">
        {summaryRows.map(([label, value]) => (
          <div key={label} className="summary-row">
            <span className="summary-label">{label}</span>
            <span className="summary-value">{String(value)}</span>
          </div>
        ))}
      </div>
      <div className="extra-fields" id="extraFields">
        {extraFields.map((field) => (
          <div key={field.field} className="field-group">
            <label htmlFor={`extra_${field.field}`}>{field.label || EXTRA_FIELD_LABELS[field.field]}</label>
            <input
              type="text"
              id={`extra_${field.field}`}
              placeholder={`Informar ${field.label || EXTRA_FIELD_LABELS[field.field]}`}
              value={field.value}
              onChange={(event) => onExtraFieldChange(field.field, event.target.value)}
            />
            {field.helperText ? (
              <div style={{ marginTop: "0.35rem", color: "var(--text-muted)", fontSize: "0.85rem" }}>
                {field.helperText}
              </div>
            ) : null}
          </div>
        ))}
      </div>
      <SummaryExport
        exportType={exportType}
        exportSnapshot={exportSnapshot}
        onExportTypeChange={onExportTypeChange}
      />
    </>
  );
}
